import { Step, StepButton, Stepper as MuiStepper } from '@mui/material'
import React from 'react'
import { FormStepProps } from 'hooks/stepper.hook'

type StepperProps = {
  steps: FormStepProps[]
  activeStep: number
  onChangeStep: (index: number) => void
}

const Stepper: React.FC<StepperProps> = ({ steps, activeStep, onChangeStep }) => {
  return (
    <MuiStepper nonLinear alternativeLabel activeStep={activeStep} sx={{ mb: 4 }} color='secondary'>
      {steps.map((step) => (
        <Step key={step.index}>
          <StepButton onClick={() => onChangeStep(step.index)}>{step.title}</StepButton>
        </Step>
      ))}
    </MuiStepper>
  )
}

export default Stepper
